import { useEffect, useState } from 'react'

import { SET_DECK_STATE } from 'redux/deck/actions/types'
import { DeckState, generateInitialDeckState } from 'redux/deck/initialState'
import { useActionless } from 'redux/hooks'

import DeckService from 'services/deck.service'
import ToastService from 'services/toast.service'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'

import { deckResponseToDeckState } from 'utils/responseToDeck'

import styles from './deckDetailsFetchingOverlayWrapper.module.scss'

type Props = {
  open: boolean
  onClose: () => void
  deckId: string | number
  children: React.ReactNode
  initialDeckState?: Partial<DeckState>
}

const DeckDetailsFetchingOverlayWrapper = ({ open, onClose, deckId, children, initialDeckState = {} }: Props) => {
  const [loading, setLoading] = useState(true)

  const [setDeckState] = useActionless(SET_DECK_STATE)

  useEffect(() => {
    if (!open) return

    DeckService.details(`${deckId}`)
      .then(deck => {
        const cleanDeckState = generateInitialDeckState()
        const mergedDeckStates = deckResponseToDeckState({ ...cleanDeckState, ...initialDeckState }, deck)

        setDeckState(mergedDeckStates)
      })
      .catch(() => ToastService.create('Unable to fetch deck', 'Deck Service', 'error'))
      .finally(() => setLoading(false))
  }, [open])

  return (
    <GlobalOverlayStack open={open} onClose={onClose} className={styles.content}>
      {loading && <div>Loading...</div>}
      {!loading && <>{children}</>}
    </GlobalOverlayStack>
  )
}

export default DeckDetailsFetchingOverlayWrapper
